export const BLOCKSCOUT_URL = process.env.REACT_APP_BLOCKSCOUT_URL
export const STEP_CHAIN_ID = process.env.REACT_APP_STEP_CHAIN_ID
export const FUJI_CHAIN_ID = process.env.REACT_APP_FUJI_CHAIN_ID
export const BRIDGE_STEP_ADDRESS = process.env.REACT_APP_BRIDGE_STEP_ADDRESS
export const BRIDGE_C_ADDRESS = process.env.REACT_APP_BRIDGE_C_ADDRESS
export const FITFI_CONTRACT_ADDRESS = process.env.REACT_APP_FITFI_CONTRACT_ADDRESS
export const HOST = process.env.REACT_APP_HOST
